// extracted by mini-css-extract-plugin
export var content = "_oh-1";
export var fullScreen = "_oh-0";